import api from '../api'
import { setLiveConfigurationCache } from '../utils/configuration/configurationCache'

// https://docs.google.com/document/d/1gRlNTH9DLnb7qLSnBNCzVZdGusWV11lXPGuFkcTWMQM/edit#heading=h.uzf9e4y6wybz

export function fetchConfiguration() {
  return (dispatch, getState) => api.fetch('/configuration')
    .then((response) => {
      console.log('configuration fetched:', response)
      const payload = {
        ...response,
        fetchedAt: new Date(),
      }
      const { initialConfiguration } = getState()
      if (!initialConfiguration) {
        dispatch({
          type: 'FETCH_INITIAL_CONFIGURATION_SUCCESS',
          response: payload,
        })
      }
      dispatch({
        type: 'FETCH_CONFIGURATION_SUCCESS',
        response: payload,
      })

      setLiveConfigurationCache(payload)
    })
    .catch((error) => error)
}
